import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "WaveInvoicePanelInformation h-full" }
const _hoisted_2 = {
  key: 0,
  class: "flex flex-col items-center justify-center text-sm select-none text-gray-400 py-8 px-6"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "mt-1" }, "Загрузка данных накладной...", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "text-red-500" }, "При получении данных накладной произошла ошибка", -1)
const _hoisted_5 = { key: 2 }
const _hoisted_6 = {
  key: 1,
  class: "flex flex-col justify-between h-full"
}
const _hoisted_7 = { class: "py-8 px-6" }
const _hoisted_8 = { class: "flex items-center justify-between" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "font-bold" }, "Информация по накладной", -1)
const _hoisted_10 = { class: "mt-3 grid grid-cols-2 gap-3" }
const _hoisted_11 = { class: "mt-3 grid grid-cols-2 gap-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader = _resolveComponent("loader")!
  const _component_new_button = _resolveComponent("new-button")!
  const _component_cheap = _resolveComponent("cheap")!
  const _component_the_input = _resolveComponent("the-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.state.is_loading || _ctx.state.is_failed || !_ctx.state.invoice)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.state.is_loading)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_component_loader, { class: "primary" }),
                _hoisted_3
              ], 64))
            : (_ctx.state.is_failed)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _hoisted_4,
                  _createVNode(_component_new_button, {
                    class: "NewButton--outline mt-1",
                    onClick: _ctx.loadInvoice
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Обновить ")
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ], 64))
              : (!_ctx.state.invoice)
                ? (_openBlock(), _createElementBlock("p", _hoisted_5, "Нет данных"))
                : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              (_ctx.form.deliveryStatus)
                ? (_openBlock(), _createBlock(_component_cheap, {
                    key: 0,
                    class: "small"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.form.deliveryStatus), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _createVNode(_component_the_input, {
              class: "mt-3",
              placeholder: "№ Накладной",
              value: _ctx.form.invoiceNumber,
              disabled: ""
            }, null, 8, ["value"]),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_the_input, {
                placeholder: "Физ вес",
                value: _ctx.form.weight,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.weight) = $event)),
                disabled: ""
              }, null, 8, ["value"]),
              _createVNode(_component_the_input, {
                placeholder: "Объемный вес",
                value: _ctx.form.volumeWeight,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.volumeWeight) = $event)),
                disabled: ""
              }, null, 8, ["value"])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_the_input, {
                placeholder: "Дата создания",
                value: _ctx.form.createdAt,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.createdAt) = $event)),
                disabled: ""
              }, null, 8, ["value"]),
              _createVNode(_component_the_input, {
                placeholder: "Дата доставки",
                disabled: "",
                value: _ctx.state.deliveryDate
              }, null, 8, ["value"])
            ])
          ])
        ]))
  ]))
}